var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliderBarDialogShell',{ref:"sliderbar",staticClass:"add-article-dialog",attrs:{"dialog-show":_vm.dialogShow,"dialog-title":_vm.title},on:{"close":_vm.beforeClose,"submit":_vm.confirm}},[_c('msg-reply-form',{ref:"outform",on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }